<div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row">
                <div fxFlex="99" style="background-color: #fff;padding:10px;color:#20273B;text-align: center;">
                <h6 class="section-header">DOCUMENT UPLOAD</h6>
                </div>
                    <div fxFlex="99" class="p-3">
                        <mat-form-field>
                            <mat-select placeholder="Title" [(ngModel)]="selectedTitle"  (ngModelChange)="selectTitle()">
                                <mat-option *ngFor="let option of options" [value]='option.value'>{{option.value}}</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <form action="" [formGroup]="documentForm">
                            <mat-form-field *ngIf="others">
                                <mat-label>Title</mat-label>
                                <input type="text" matInput placeholder="Title" id="dtitle" name="title" formControlName="title" required="" />
                            </mat-form-field>
    
                            <mat-form-field>
                                <mat-label>Description</mat-label>                          
                                <input type="text" id="ddesc" matInput placeholder="Description" formControlName="desc" required="" />
                            </mat-form-field>
                            
                            <input #fileInput style="display:none" type="file" (change)="onFileSelected($event)" required  />

                            <button mat-raised-button (click)="fileInput.click()">Select File</button>
                            
                            <button type="button" color="primary" (click)="onUpload()" [disabled]="documentForm.invalid" mat-raised-button id="save">Save</button><br /><br />
                        </form>
                        
                        <mat-progress-bar [style.display]="progressbarDisplay" mode="determinate" value="{{progressbarValue}}"></mat-progress-bar>
                        <p><small><strong>{{pro}}</strong></small></p>
                    </div>
            </div>
        </div>
    </div>
</div>